export default __webpack_public_path__ + "static/media/restraunt-image.c906d930.jpg";